import { render, staticRenderFns } from "./DemForm.vue?vue&type=template&id=86d014ba&lang=pug"
import script from "./DemForm.vue?vue&type=script&lang=js"
export * from "./DemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports